<div class="Typography margin-bottom modal-title">
  <h3 class="no-margin margin-bottom margin-top">
    Property management company
  </h3>
</div>
<form [formGroup]="companyForm">
  <div class="form-row">
    <div class="form-col">
      <mat-form-field
        class="mat-form-field-100"
        appearance="outline"
      >
        <mat-label style="font-size: 16px !important"
          >Property management company name</mat-label
        >
        <input
          matInput
          class="form-outline form-control"
          formControlName="propertyName"
          placeholder="Property management company name"
          [matAutocomplete]="autoProperty"
        />
        <mat-autocomplete #autoProperty="matAutocomplete">
          <mat-option
            *ngFor="let suggestion of propertySuggestions"
            [value]="suggestion.name"
            (onSelectionChange)="selectPlace(suggestion)"
          >
            {{ suggestion.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error>Property management company name is required</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row">
    <div class="form-col">
      <mat-form-field
        class="mat-form-field-100"
        appearance="outline"
      >
        <mat-label style="font-size: 16px !important"
          >Property management company Street address</mat-label
        >
        <input
          matInput
          class="form-outline form-control"
          placeholder="Property street address"
          formControlName="streetAddress"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option
            *ngFor="let suggestion of suggestions"
            [value]="suggestion.description"
            (onSelectionChange)="selectPlace(suggestion)"
          >
            {{ suggestion.description }}
          </mat-option>
        </mat-autocomplete>
        <mat-error>Property management company Street address</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row">
    <div class="form-col">
      <mat-form-field
        class="mat-form-field-100"
        appearance="outline"
      >
        <mat-label style="font-size: 16px !important"
          >Apt/Unit/Suite</mat-label
        >
        <input
          matInput
          formControlName="aptUnitSuite"
          placeholder="Apt/Unit/Suite"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="form-row">
    <div class="form-col">
      <mat-form-field
        class="mat-form-field-95"
        appearance="outline"
      >
        <mat-label style="font-size: 16px !important">City</mat-label>
        <input matInput formControlName="city" placeholder="City" />
        <mat-error>City is required</mat-error>
      </mat-form-field>
    </div>
    <div class="form-col">
      <mat-form-field
        class="mat-form-field-100"
        appearance="outline"
      >
        <mat-label>State</mat-label>
        <mat-select formControlName="state" placeholder="State">
          @for (state of states; track state) {
          <mat-option [value]="state.id">{{
            state.name
          }}</mat-option>
          }
        </mat-select>
        <mat-error>State is required</mat-error>
      </mat-form-field>
    </div>
    <div class="form-col">
      <mat-form-field
        class="mat-form-field-95"
        appearance="outline"
      >
        <mat-label style="font-size: 16px !important">Zip code</mat-label>
        <input matInput formControlName="zipCode" placeholder="Zip Code" />
        <mat-error
          *ngIf="this.companyForm.get('zipCode')?.errors?.['pattern'] && (companyForm.get('zipCode')?.touched)"
          >Zip Code is invalid</mat-error
        >

        <mat-error
          *ngIf="this.companyForm.get('zipCode')?.errors?.['required'] && (companyForm.get('zipCode')?.touched)"
          >Zip Code is required</mat-error
        >
      </mat-form-field>
    </div>
  </div>
</form>

<div
  class="Dialogactions"
  style="
    width: 100%;
    height: 100%;
    padding: 8px;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    display: inline-flex;
  "
>
  <button
    (click)="dialogRef.close()"
    mat-stroked-button
    mat-button
    mat-dialog-close
    class="button-stepper-allow-outline"
  >
    GO BACK
    <mat-icon>arrow_left_alt</mat-icon>
  </button>
  <button
    [disabled]="!companyForm.valid"
    [ngClass]="{
      'button-stepper-allow': companyForm.valid,
      'button-stepper': companyForm.invalid
    }"
    mat-stroked-button
    mat-button
    (click)="save()"
    class="button-stepper-allow"
  >
    SAVE <mat-icon>save</mat-icon>
  </button>
</div>
